import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { 
  registerIndividualClient, 
  registerContratorClient, 
  registerConsultativeClient, 
  registerGovClient, 
  checkLoginName, 
  checkPasswordPower, 
  registerotherClients,
  checkPhoneNo,
  checkEmailAddress, 
} from "api/registerAPI";
import { getDealingTypes, getEntites, getEmirates } from "api/dropdownsAPI";

export const fetchEmirates = createAsyncThunk("register/fetchEmirates", async (param, { signal, rejectWithValue }) => {
  try {
    const source = axios.CancelToken.source();
    signal.addEventListener("abort", () => {
      source.cancel();
    });
    const response = await getEmirates(param, {
      cancelToken: source.token,
    });
    if (response?.Status) {
      return response.Data;
    }
  } catch (err) {
    if (!err?.Status) {
      return rejectWithValue(err.Data);
    }
    if (axios.isCancel(err)) {
      rejectWithValue(err.message);
    }
  }
});

const slice = createSlice({
  name: "register",
  initialState: {
    dealingTypes: [],
    governmentEntities: [],
    emirates: [],
    loadingEmirates: "idle",
    validLoginName: "",
    validPassword: "",
    validPhoneNumber: "",
    validEmail: "",
    passwordPower: -1,
  },
  reducers: {
    registerSuccess: (state) => {
      state.validLoginName = "";
      state.passwordPower = -1;
      state.validPassword = "";
      state.validPhoneNumber = "";
      state.validEmail = "";
    },
    dealingTypesSuccess: (state, { payload }) => {
      state.dealingTypes = payload;
    },
    governmentEntitiesSuccess: (state, { payload }) => {
      state.governmentEntities = payload;
    },
    checkLoginSuccess: (state, { payload }) => {
      state.validLoginName = payload?.Login_Name_Valid;
    },
    checkPasswordSuccess: (state, { payload }) => {
      state.validPassword = payload?.Password_Valid;
      state.passwordPower = payload?.Password_Power;
    },
    checkPhoneNoSuccess: (state, { payload }) => {
      state.validPhoneNumber = payload?.Client_Phone_Valid;
    },
    checkEmailSuccess: (state, { payload }) => {
      state.validEmail = payload?.Client_Mail_Valid;
    }
  },
  extraReducers: {
    [fetchEmirates.pending]: (state) => {
      if (state.loadingEmirates === "idle") {
        state.loadingEmirates = "pending";
      }
    },
    [fetchEmirates.fulfilled]: (state, { payload }) => {
      if (state.loadingEmirates === "pending") {
        state.loadingEmirates = "idle";
        console.log(payload);
        state.emirates = payload;
      }
    },
    [fetchEmirates.rejected]: (state, action) => {
      if (state.loadingEmirates === "pending") {
        state.loadingEmirates = "idle";
        state.error = action.error;
      }
    },
  },
});
export default slice.reducer;

export const { 
  registerSuccess, 
  dealingTypesSuccess, 
  governmentEntitiesSuccess, 
  emiratesSuccess, 
  checkLoginSuccess, 
  checkPasswordSuccess,
  checkPhoneNoSuccess, 
  checkEmailSuccess,
} = slice.actions;

export const registerIndividual = (param, source, setSubmitting, setShowSubmitLoading, resetForm) => async (dispatch) => {
  try {
    let cancelToken;
    if (source) {
      cancelToken = { cancelToken: source.token };
    }
    const res = await registerIndividualClient(param, cancelToken);

    if (res?.Status) {
      dispatch(registerSuccess());
    }
    if (!res?.Status) {
      // api errors
    }
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("cancelled");
    } else {
      console.error(error);
    }
  } finally {
    setSubmitting(false);
    resetForm()
    setShowSubmitLoading(false);
  }
};
export const registerContrator = (param, source, setSubmitting, setShowSubmitLoading, resetForm) => async (dispatch) => {
  try {
    let cancelToken;
    if (source) {
      cancelToken = { cancelToken: source.token };
    }
    const res = await registerContratorClient(param, cancelToken);

    if (res?.Status) {
      dispatch(registerSuccess());
    }
    if (!res?.Status) {
      // api errors
    }
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("cancelled");
    } else {
      console.error(error);
    }
  } finally {
    setSubmitting(false);
    resetForm()
    setShowSubmitLoading(false);
  }
};
export const registerConsultative = (param, source, setSubmitting, setShowSubmitLoading, resetForm) => async (dispatch) => {
  try {
    let cancelToken;
    if (source) {
      cancelToken = { cancelToken: source.token };
    }
    const res = await registerConsultativeClient(param, cancelToken);

    if (res?.Status) {
      dispatch(registerSuccess());
    }
    if (!res?.Status) {
      // api errors
    }
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("cancelled");
    } else {
      console.error(error);
    }
  } finally {
    setSubmitting(false);
    resetForm()
    setShowSubmitLoading(false);
  }
};
export const registerGovermentalEntities = (param, source, setSubmitting, setShowSubmitLoading, resetForm) => async (dispatch) => {
  try {
    let cancelToken;
    if (source) {
      cancelToken = { cancelToken: source.token };
    }
    const res = await registerGovClient(param, cancelToken);

    if (res?.Status) {
      dispatch(registerSuccess());
    }
    if (!res?.Status) {
      // api errors
    }
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("cancelled");
    } else {
      console.error(error);
    }
  } finally {
    setSubmitting(false);
    resetForm()
    setShowSubmitLoading(false);
  }
};
export const registerOthersProfile = (param, source, setSubmitting, setShowSubmitLoading, resetForm) => async (dispatch) => {
  try {
    let cancelToken;
    if (source) {
      cancelToken = { cancelToken: source.token };
    }
    const res = await registerotherClients(param, cancelToken);

    if (res?.Status) {
      dispatch(registerSuccess());
    }
    if (!res?.Status) {
      // api errors
    }
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("cancelled");
    } else {
      console.error(error);
    }
  } finally {
    setSubmitting(false);
    resetForm()
    setShowSubmitLoading(false);
  }
};
export const checkLogin = (param, source) => async (dispatch) => {
  try {
    let cancelToken;
    if (source) {
      cancelToken = { cancelToken: source.token };
    }
    const res = await checkLoginName(param, cancelToken);

    if (res?.Status) {
      dispatch(checkLoginSuccess(res.Data));
    }
    if (!res?.Status) {
    }
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("cancelled");
    } else {
      console.error(error);
    }
  } finally {
    //cleansing callbacks
  }
};
export const checkPassword = (param, source) => async (dispatch) => {
  try {
    let cancelToken;
    if (source) {
      cancelToken = { cancelToken: source.token };
    }
    const res = await checkPasswordPower(param, cancelToken);

    if (res?.Status) {
      dispatch(checkPasswordSuccess(res.Data));
    }
    if (!res?.Status) {
      // api errors
    }
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("cancelled");
    } else {
      console.error(error);
    }
  } finally {
    //cleansing callbacks
  }
};
export const checkPhone = (param, source) => async (dispatch) => {
  try {
    let cancelToken;
    if (source) {
      cancelToken = { cancelToken: source.token };
    }
    const res = await checkPhoneNo(param, cancelToken);

    if (res?.Status) {
      dispatch(checkPhoneNoSuccess(res?.Data));
    }
    if (!res?.Status) {
    }
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("cancelled");
    } else {
      console.error(error);
    }
  } finally {
  }
};
export const checkEmail = (param, source) => async (dispatch) => {
  try {
    let cancelToken;
    if (source) {
      cancelToken = { cancelToken: source.token };
    }
    const res = await checkEmailAddress(param, cancelToken);

    if (res?.Status) {
      dispatch(checkEmailSuccess(res?.Data));
    }
    if (!res?.Status) {
    }
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("cancelled");
    } else {
      console.error(error);
    }
  } finally {
  }
};

export const fetchDealingTypes = (param, source) => async (dispatch) => {
  try {
    let cancelToken;
    if (source) {
      cancelToken = { cancelToken: source.token };
    }

    const res = await getDealingTypes(param, cancelToken);

    if (res?.Status) {
      dispatch(dealingTypesSuccess(res.Data));
    }
    if (!res?.Status) {
    }
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("cancelled");
    } else {
      console.error(error);
    }
  } finally {
    // setSubmitting(false);
  }
};
export const fetchEntities = (param, source) => async (dispatch) => {
  try {
    let cancelToken;
    if (source) {
      cancelToken = { cancelToken: source.token };
    }

    const res = await getEntites(param, cancelToken);

    if (res?.Status) {
      dispatch(governmentEntitiesSuccess(res.Data));
    }
    if (!res?.Status) {
    }
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("cancelled");
    } else {
      console.error(error);
    }
  } finally {
    // setSubmitting(false);
  }
};
// export const fetchEmirates = (param, source) => async (dispatch) => {
//   try {
//     let cancelToken;
//     if (source) {
//       cancelToken = { cancelToken: source.token };
//     }

//     const res = await getEmirates(param, cancelToken);

//     if (res?.Status) {
//       dispatch(emiratesSuccess(res.Data));
//     }
//     if (!res?.Status) {
//     }
//   } catch (error) {
//     if (axios.isCancel(error)) {
//       console.log("cancelled");
//     } else {
//         console.error(error);
//     }
//   } finally {
//     // setSubmitting(false);
//   }
// };
